import ModulePage from "../ModulePage/ModulePage";

const OfertaUniversitaria = () => <ModulePage />;

export default OfertaUniversitaria;
